const t = [];
for (let o = 0; o < 256; o++)
  t.push(0);
"\\!\"#$%&'()*+,./:;<=>?@[]^_`{|}~-".split("").forEach(function(o) {
  t[o.charCodeAt(0)] = 1;
});
